import React from 'react';

export const NoMediaCollected = ({ ...rest }) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 147 134.11"
      {...rest}
    >
      <defs>
        <style>
          {`
            .cls-1,.cls-3{
            fill:var(--primary-200);
            }
            .cls-2,.cls-7{
            fill:none;
            }
            .cls-2{
            stroke:var(--primary-200);
            }
            .cls-3,.cls-4,.cls-5,.cls-7{
            stroke:var(--primary-800);
            }
            .cls-4{
            fill:var(--primary-600);
            fill-opacity:0.15;
            }
            .cls-5{
            fill:#fff;
            }
            .cls-6{
            fill:var(--primary-800);
            }
            .cls-7{
            stroke - width:2px;
            }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="M18,15h0a6,6,0,0,1,6,6h0a6,6,0,0,1-6,6h0a6,6,0,0,1-6-6h0A6,6,0,0,1,18,15Z"
      />
      <path
        className="cls-2"
        d="M12,73.5h0A11.5,11.5,0,0,1,23.5,85h0A11.5,11.5,0,0,1,12,96.5h0A11.5,11.5,0,0,1,.5,85h0A11.5,11.5,0,0,1,12,73.5Z"
      />
      <path
        className="cls-1"
        d="M129,117h0a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4h0A4,4,0,0,1,129,117Z"
      />
      <path
        className="cls-2"
        d="M136,73.5h0a3.5,3.5,0,0,1,3.5,3.5h0a3.5,3.5,0,0,1-3.5,3.5h0a3.5,3.5,0,0,1-3.5-3.5h0A3.5,3.5,0,0,1,136,73.5Z"
      />
      <path
        className="cls-2"
        d="M138,19.5h0a8.51,8.51,0,0,1,8.5,8.5h0a8.51,8.51,0,0,1-8.5,8.5h0a8.51,8.51,0,0,1-8.5-8.5h0A8.51,8.51,0,0,1,138,19.5Z"
      />
      <path
        className="cls-1"
        d="M84,0h0a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4h0A4,4,0,0,1,84,0Z"
      />
      <rect
        className="cls-3"
        x="26.67"
        y="40.84"
        width="99"
        height="72"
        rx="5.5"
        transform="translate(-18.01 130.08) rotate(-74.73)"
      />
      <rect
        className="cls-4"
        x="40.17"
        y="27.34"
        width="72"
        height="99"
        rx="5.5"
        transform="translate(-20.03 27.33) rotate(-18.02)"
      />
      <path
        className="cls-5"
        d="M39.5,33A5.5,5.5,0,0,1,45,27.5H95.28a5.5,5.5,0,0,1,4.14,1.88l10.72,12.25a5.5,5.5,0,0,1,1.36,3.62V121a5.5,5.5,0,0,1-5.5,5.5H45a5.5,5.5,0,0,1-5.5-5.5Z"
      />
      <path
        className="cls-1"
        d="M91,33.82a2,2,0,0,1,3.5-1.19l12.3,14a2,2,0,0,1-1.63,3.32L92,49.09A2,2,0,0,1,90.13,47Z"
      />
      <path
        className="cls-5"
        d="M94.47,30.85A1.5,1.5,0,0,1,97.09,30l12.3,14a1.5,1.5,0,0,1-1.22,2.49L95,45.59A1.5,1.5,0,0,1,93.63,44Z"
      />
      <path
        className="cls-6"
        d="M81.29,76.19a1.54,1.54,0,0,1,0,2.62l-7.92,5A1.55,1.55,0,0,1,71,82.45v-9.9a1.55,1.55,0,0,1,2.37-1.31Z"
      />
      <path
        className="cls-7"
        d="M75.5,61h0A16.5,16.5,0,0,1,92,77.5h0A16.5,16.5,0,0,1,75.5,94h0A16.5,16.5,0,0,1,59,77.5h0A16.5,16.5,0,0,1,75.5,61Z"
      />
    </svg>
  );
};

export default NoMediaCollected;



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/NoMediaCollected.jsx